<script setup lang="ts">
import BadgeHype from '~/components/ui/BadgeHype.vue'
//* We keep using the old one since the new one doesn't handle the overflow hidden containers well
import VTooltip from '~/components/ui/VTooltip.vue'

type Props = {
  defaultTooltipPosition?: 'above' | 'below'
  hideHypeText?: boolean
}

withDefaults(defineProps<Props>(), {
  defaultTooltipPosition: 'below',
  hideHypeText: false,
})

const isTooltipDisplayed = ref(false)
</script>

<template>
  <VTooltip
    show-when-clicked
    html-tag="button"
    type="button"
    :position="defaultTooltipPosition"
    @show="isTooltipDisplayed = true"
    @hide="isTooltipDisplayed = false"
  >
    <template #default
      ><BadgeHype
        :darken-bg="isTooltipDisplayed"
        :hide-hype-text="hideHypeText"
    /></template>
    <template #tooltipText>{{ $t('hype.trackIsHypeTooltipText') }}</template>
    <template #cta>
      <NuxtLink
        external
        rel="noopener"
        target="_blank"
        :to="$t('hype.artistFAQLink')"
        class="tw-mt-2 tw-underline hover:tw-underline md:tw-block"
        ><span class="tw-text-body-sm tw-font-medium">{{
          $t('common.learnMore')
        }}</span></NuxtLink
      >
    </template>
  </VTooltip>
</template>
